/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type Plan =
  /** V2021_1 エンタープライズプラン */
  | 'V2021_1Enterprise'
  /** V2021_1 プレミアムプラン */
  | 'V2021_1Premium'
  /** V2021_1 スタンダードプラン */
  | 'V2021_1Standard'
  /** V2022_1 Enterpriseプラン */
  | 'V2022_1Enterprise'
  /** V2022_1 Entryプラン */
  | 'V2022_1Entry'
  /** V2022_1 PRプラン */
  | 'V2022_1PR'
  /** V2022_1 Proプラン */
  | 'V2022_1Pro'
  /** V2022_2 管理者専用無料プラン */
  | 'V2022_2ManageOnlyFree'
  /** V2023_1 エンタープライズプラン */
  | 'V2023_1Enterprise'
  /** V2023_1 エキスパートプラン */
  | 'V2023_1Expert'
  /** V2023_1 管理者専用無料プラン */
  | 'V2023_1ManageOnlyFree'
  /** V2023_1 マスタープラン */
  | 'V2023_1Master'
  /** V2023_1 スキルフォースプラン */
  | 'V2023_1SkillForce';

export type AccountEditorTableViewerFragment = { plan: Types.Plan, channels: Array<{ id: Types.Channel, name: string }> };

export const AccountEditorTableViewerFragmentDoc = gql`
    fragment AccountEditorTableViewer on Viewer {
  plan
  channels {
    id
    name
  }
}
    `;